module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av118-2f0a02e64eeb2826c22570503633f9c0.jpg";